import Cookies from 'js-cookie';
import { AnalyticKey } from '../constants';

export const NO_TRACKER_VALUE = 'no_ga_tracker_created';

export const getGoogleAnalyticClientId = (): string => {
  const gaClientId = Cookies.get(AnalyticKey.GA_COOKIE);

  if (!gaClientId) {
    return NO_TRACKER_VALUE;
  }

  const parsedClientId = gaClientId.split('.').splice(2).join('.');

  return parsedClientId;
};
